import data from './data';
import headerSettings from './headerSettings';

const root = {
	data,
	headerSettings
};

export default root;
